<template>
    <DashboardWidgetAnalisiReddituale class="widget-analisi-reddituale-consuntiva" title="Analisi Reddituale Consuntiva" :values="values" />
</template>

<script>

export default {
  components: {
    DashboardWidgetAnalisiReddituale: () => import('./DashboardWidgetAnalisiReddituale.vue'),
  },
  props: {
    values: {
      type: Array,
      default: null,
    },
  },
};

</script>
